<div *ngIf="videoAvailable" class="container-fluid video-container">
    <div class="video-container__overlay"></div>
    <div class="video-container__play">
        <a href="#" data-bs-toggle="modal" data-bs-target="#videoModal">
            <i class="fa fa-play-circle"></i>
        </a>
        <h4>See what sets us apart</h4>
    </div>
   
  </div>

  <!-- Trigger Button -->
<!-- <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#videoModal">
    Open YouTube Video
  </button> -->
  
  <!-- Bootstrap Modal -->
  <div *ngIf="videoAvailable" class="modal fade" id="videoModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header border-1 ps-4">
            <span>Learn more about us</span>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4 custom-modal-body">
          <div class="ratio ratio-16x9">
            <iframe  id="youtubeFrame" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
